<div class="coming-soon-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-xl-4 col-lg-5">
                <div class="coming-soon-content">
                    <h2>We Are Coming Soon</h2>
                    <div class="newsletter-form">
                        <form>
                            <div class="form-group">
                                <input type="email" name="email" id="emailAddress" class="form-control" placeholder="Email Address">
                                <button type="submit" name="submit" value="Go" class="filled-btn"><i class="fas fa-arrow-right"></i></button>
                            </div>
                        </form>
                        <div class="newsletter-notice">
                            <p>Join With Us To Get More Update</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-lg-7">
                <div class="coming-soon-image">
                    <img src="assets/img/coming-soon.png" alt="coming soon">
                </div>
            </div>
        </div> <!-- /.row -->
    </div> <!-- /.container -->
</div>